<template>
  <v-card class="manageCodeList col-12 mt-0 mb-4 pb-0">
    <div class="row justify-end mt-0 mb-0">
      <div class="row justify-start mt-0 mb-0" style="padding-left: 25px;">
        <v-btn small color="grey darken-4" class="white--text" @click="removeCode()">시리얼 코드 파기</v-btn>
      </div>
      <v-btn small color="green" class="white--text mr-3" @click.prevent="excelDownload">엑셀 다운로드</v-btn>
    </div>

    <v-data-table
      v-model="selectedProduct"
      :headers="headers"
      :items="productInfos"
      :server-items-length="productInfosCount"
      :options.sync="options"
      :loading="tableLoading"
      calculate-widths
      show-select
      :items-per-page="$parent.$refs.searchComponent.searchPayload.limit"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
        'items-per-page-text': '목록 노출 수 선택:',
      }"
      item-key="id"
      scrollable
    >
      <template v-slot:[`item.created`]="{ item }">
        <p class="mb-0 mt-3 text-center caption" v-html="$options.filters.defaultDate(item.created_at)"></p>
      </template>

      <template v-slot:[`item.authCode`]="{ item }">
        <p class="mb-0 mt-3 caption" @click="authCodeClick(item)">
          <a>{{ item.serial_number }}</a>
        </p>
      </template>

      <template v-slot:[`item.image`]="{ item }" class="pl-0 pr-0 ml-0 mr-0">
        <v-row no-gutters>
          <v-col>
            <v-img v-if="item.list_image" :src="item.list_image" width="60px" height="60px"></v-img>
            <v-img v-else :src="adminDefaultImg" width="60px" height="60px"></v-img>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.productInfo`]="{ item }" class="pl-0 pr-0 ml-0 mr-0">
        <v-row no-gutters>
          <v-col
            :cols="12"
            class="pl-0 pr-0 ml-0 mr-0"
            style="width:120px;overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap;"
          >
            <p class="mb-0 mt-3 mr-0 text-left text-truncate caption">
              {{ item.product_name }}
            </p>
            <p class="mb-0 mr-0 text-left text-truncate caption">옵션 : {{ item.variant_name }}</p>
            <p class="mb-0 mr-0 text-left text-truncate caption">상품코드 : {{ item.product_code }}</p>
            <p class="mb-3 mr-0 text-left text-truncate caption">품목코드 : {{ item.variant_code }}</p>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.authState`]="{ item }" class="pl-0 pr-0">
        <p class="mb-0">
          <!--a @click="authStateClick(item)" class="caption">{{ item.cert_status | certStatus }}</a-->
          {{ item.cert_status | certStatus }}
        </p>
      </template>

      <template v-slot:[`item.order_id`]="{ item }" class="pl-0 pr-0">
        <p class="mb-0 text-center caption">
          <span v-if="item.order_id">
            <a v-if="item.order_id" :href="moveEcOrderPage(item.order_id.slice(0, -3))" target="_blank">{{ item.order_id.slice(0, -3) }}</a>
          </span>
          <span v-else>-</span>
        </p>
      </template>
      <template v-slot:[`item.authDate`]="{ item }" class="pl-0 pr-0">
        <p class="mb-0 text-center caption" v-html="$options.filters.defaultDate(item.activated_at)"></p>
      </template>

      <template v-slot:[`item.member_id`]="{ item }">
        <div class="text-start my-3" v-if="item.member_name">
          <span :class="[item.member_id ? 'primary--text ' : 'my-3', 'caption', 'text-start']">
            <a :href="moveEcUserPage(item.member_id)" target="_blank" v-if="item.member_id">
              <div>
                ID :
                {{ item.member_id ? item.member_id : "비회원" }}
              </div>
              이름 :
              {{ item.member_name ? item.member_name : "-" }}
              <br />
              전화번호 :
              {{ item.member_phone ? item.member_phone : "-" }}
              <br />
              이메일 :
              {{ item.member_email ? item.member_email : "-" }}
              <!--div v-if="item.member_id">
              회원등급명 :
              {{ item.member_level ? item.member_level : "-" }}
            </div-->
            </a>
            <div v-else>
              <div>
                ID :
                {{ item.member_id ? item.member_id : "비회원" }}
              </div>
              이름 :
              {{ item.member_name ? item.member_name : "-" }}
              <br />
              전화번호 :
              {{ item.member_phone ? item.member_phone : "-" }}
              <br />
              이메일 :
              {{ item.member_email ? item.member_email : "-" }}
            </div>
          </span>
        </div>
        <div class="text-center" v-else>
          <span>-</span>
        </div>
      </template>
      <template v-slot:[`item.authUserId`]="{ item }" class="pl-0 pr-0">
        <p class="mb-0 text-center caption">
          <a v-if="item.member_id !== null" :href="moveEcUserPage(item.member_id)" target="_blank">{{ item.member_id | defaultString }}</a>
          <span v-else>{{ item.cert_status != "inactivated" ? "비회원" : item.member_id | defaultString }}</span>
        </p>
      </template>
      <template v-slot:[`item.resend`]="{ item }" class="pl-0 pr-0">
        <p class="mb-0 text-center caption">
          <v-btn v-if="item.cert_status === 'activated'" small color="blue darken-4" class="white--text" @click.prevent="resendCode(item)">
            재발송
          </v-btn>
          <span v-else>-</span>
        </p>
      </template>
      <template slot="no-data">
        <div class="noDataProductInfos">내역이 없습니다.</div>
      </template>
    </v-data-table>

    <!--
      Modal
    -->
    <v-row justify="center">
      <v-dialog persistent max-width="310" v-model="removeConfirm">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text>
            <p class="mb-0">선택하신 시리얼코드를 파기하시면</p>
            <p class="mb-0">관련된 이력과 함께 모두 사라지게 됩니다.</p>
            <p class="mb-0">정말로 파기하시겠습니까?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black darken-1" text @click.prevent="removeConfirm = false">취소</v-btn>
            <v-btn color="blue darken-1" @click.prevent="sendRemoveCode" text>파기</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <AuthCodeClickModal ref="AuthCodeClickModal"></AuthCodeClickModal>
    <AuthWarrantyPeriodChangeModal ref="AuthWarrantyPeriodChangeModal"></AuthWarrantyPeriodChangeModal>
    <UnAuthWarrantyPeriodChangeModal ref="UnAuthWarrantyPeriodChangeModal"></UnAuthWarrantyPeriodChangeModal>
    <AuthStateChangeModal ref="AuthStateChangeModal"></AuthStateChangeModal>
  </v-card>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}

.manageCodeList a {
  text-decoration: none;
}
.manageCodeList a:hover {
  text-decoration: underline;
}

.disabledBtn {
  height: 28px;
  min-width: 50px;
  padding: 0 12.4444444444px;
  font-size: 0.75rem;
  background-color: #f5f5f5;
  color: #bababa;
}
</style>
<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";
import AuthCodeClickModal from "@/components/authservice/authcode/modal/AuthCodeClickModal.vue";
import AuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/AuthWarrantyPeriodChangeModal.vue";
import UnAuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/UnAuthWarrantyPeriodChangeModal.vue";
import AuthStateChangeModal from "@/components/authservice/authcode/modal/AuthStateChangeModal.vue";
import Excel from "@/libs/excel.js";

export default {
  data() {
    return {
      AUTH_SERVICE,
      headers: [
        {
          text: "생성일시",
          align: "center",
          sortable: false,
          value: "created",
          width: 100,
        },
        {
          text: "시리얼코드",
          align: "center",
          value: "authCode",
          sortable: false,
          width: 180,
        },
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70,
        },
        {
          text: "품목 정보",
          align: "center",
          value: "productInfo",
          sortable: false,
        },
        {
          text: "주문번호",
          align: "center",
          value: "order_id",
          sortable: false,
          width: 150,
        },
        {
          text: "인증상태",
          align: "center",
          value: "authState",
          sortable: false,
          width: 130,
        },
        {
          text: "인증일시",
          align: "center",
          value: "authDate",
          sortable: false,
          width: 100,
        },
        {
          text: "회원정보",
          value: "member_id",
          sortable: false,
          width: 100,
        },
        {
          text: "코드 재발송",
          value: "resend",
          align: "center",
          sortable: false,
          width: 100,
        },
      ],
      selectedProduct: [],
      removeConfirm: false,
      productInfos: [],
      productInfosCount: 0,
      printInfo: null,
      options: {},
      tableLoading: false,
      excelData: {
        Excel: null,
        totalLimit: 200000,
        limit: 10000,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          created_at: "생성일시",
          serial_number: "시리얼코드",
          list_image: "이미지",
          product_name: "상품명",
          variant_name: "품목명",
          product_code: "상품코드",
          variant_code: "품목코드",
          order_id: "주문번호",
          cert_status: "인증상태",
          activated_at: "인증일시",
          member_id: "아이디",
          member_name: "이름",
          member_phone: "전화번호",
          member_email: "이메일",
        },
      },
      printSettingInfo: "N",
      adminDefaultImg: require("../../assets/authservice/images/admin_default.png"),
    };
  },
  components: {
    AuthCodeClickModal,
    AuthWarrantyPeriodChangeModal,
    UnAuthWarrantyPeriodChangeModal,
    AuthStateChangeModal,
  },
  mixins: [CommonMixin],
  filters: Filters,
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    //this.eventHub.$on("setList", this.setProductList);

    try {
      let data = await M.api(M.entry("/get/print"), {});
      this.printInfo = data;
      if (data) {
        if (data.print_paper == "60*48mm a4 라벨지 (일반프린터)" || data.print_paper == "선택해주세요.") {
          data.print_paper = "";
        }
        if (data.print_template == "타입1" || data.print_template == "선택해주세요.") {
          data.print_template = "";
        }

        if (data.print_paper && data.print_template) {
          this.printSettingInfo = "Y";
        }
      }
    } catch (e) {
      this.printSettingInfo = "N";
    }
  },
  watch: {
    options: {
      handler() {
        this.$parent.$refs.searchComponent.execSearch(false);
      },
      deep: true,
    },
  },
  methods: {
    setProductList: function(data) {
      this.selectedProduct = [];
      this.productInfosCount = data.count;
      data.serials.forEach((serial) => {
        if (serial.product_name) {
          serial.product_name = serial.product_name.replace(/<\/?[^>]+(>|$)/g, "");
        }
      });
      this.productInfos = data.serials;
      this.tableLoading = false;
    },
    authCodeClick: function(data) {
      this.$refs.AuthCodeClickModal.authCodeClick(data);
    },
    daysClick: function(data) {
      this.$refs.UnAuthWarrantyPeriodChangeModal.warrantyPeriodClick(data);
    },
    authStateClick: function(data) {
      this.$refs.AuthStateChangeModal.authStateClick(data);
    },
    /**
     * 엑셀 다운로드 체크
     */
    excelDownload: async function() {
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = 0;

      let data = await M.api(M.entry("/cert/serials/search"), excelPayload);
      if (data.length === 0) {
        this.alertShow("엑셀다운로드할 데이터가 없습니다.");
        return false;
      }
      this.excelData.totalCount = data.count;
      if (this.excelData.totalCount > this.excelData.totalLimit) {
        this.alertShow(
          "엑셀다운로드건수는 " +
            this.$options.filters.numberFormat(this.excelData.totalLimit) +
            "건</br>이내로 검색하여 다운로드 해주세요.",
        );
        return false;
      }

      data.serials.forEach((serial) => {
        if (serial.product_name) {
          serial.product_name = serial.product_name.replace(/<\/?[^>]+(>|$)/g, "");
        }
      });
      this.excelData.sheetData = data.serials;

      this.checkExcelDataChange();
      this.initExcelDownload();
    },
    /**
     * 엑셀 시작
     */
    initExcelDownload: function() {
      let progressText = "엑셀 다운로드중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);
      // this.defaultProgressShow();
      this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
      this.addExcel();
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function() {
      this.excelData.offset = this.excelData.offset + this.excelData.limit;
      this.circularProgressSetValue(Math.round((this.excelData.offset / this.excelData.totalCount) * 100));
      if (this.excelData.offset > this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = this.excelData.offset;
      let data = await M.api(M.entry("/cert/serials/search"), excelPayload);
      if (data.length === 0) {
        await this.endExcel();
        return false;
      }

      this.excelData.sheetData = data.serials;
      this.checkExcelDataChange();
      this.excelData.Excel.addSheet(this.excelData.sheetData);
      this.addExcel();
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function() {
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
        await this.excelData.Excel.addSheet(this.excelData.sheetData);
        await this.getExcelDataAdd();
      } else {
        await this.getExcelDataAdd();
      }
    },
    /**
     * 파일 다운
     */
    endExcel: async function() {
      setTimeout(() => {
        this.circularProgressHide();
      }, 1500);
      // this.defaultProgressHide();
      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(`${year}${month}${day}_${this.$store.state.mallId}`);
    },
    /**
     * excel데이터 변경
     */
    checkExcelDataChange: function() {
      if (this.excelData.sheetData.length > 0) {
        this.excelData.sheetData.forEach((data) => {
          for (let key in data) {
            if (key === "member_id") {
              if (!data[key] && data["cert_status"] !== "미인증") {
                data[key] = "비회원";
              }
            }
            if (key === "order_id" && data[key]) {
              data[key] = data[key].slice(0, -3);
            }
            if (key === "cert_status") {
              data[key] = this.$options.filters.certStatus(data[key]);
            }
            if (key === "cert_duration_type") {
              data[key] = this.$options.filters.warrantyPeriod(data).replace("</br>", "");
            }
          }
        });
      }
    },
    removeCode: async function() {
      if (this.selectedProduct.length === 0) {
        this.alertShow("파기하실 시리얼 코드를 선택해주세요.");
      } else {
        this.removeConfirm = true;
      }
    },
    sendRemoveCode: async function() {
      let payload = {
        cert_product_ids: this.selectedProduct.map((item) => item.id),
      };
      try {
        let result = await M.api(M.entry("/serials/del/by-id"), payload);
        this.removeConfirm = false;
        if (result && result.error_ids && result.error_ids.length > 0) {
          let expected = result.expected_count != null ? result.expected_count : payload.cert_product_ids.length;
          let actual = result.actual_count != null ? result.actual_count : expected - result.error_ids.length;
          this.alertShow(`일부 시리얼 코드 파기에 실패했습니다. (요청 ${expected}건 / 처리 ${actual}건)`);
        }
        this.$parent.$refs.searchComponent.execSearch(false);
      } catch (e) {
        this.removeConfirm = false;
        this.alertShow("현재 서버 통신이 불안정합니다. 잠시 후 사용해주세요.");
      }
    },
    resendCode: async function(item) {
      if (item.cert_status === "activated") {
        try {
          let data = await M.api(M.entry("/post/send/serial/resend", item.serial_number));
          if (data) {
            this.alertShow("인증코드가 재발송되었습니다.");
          }
        } catch (e) {
          this.alertShow("인증코드 재발송에 실패했습니다. 잠시 후 다시 시도해주세요.");
        }
      } else {
        this.alertShow("인증된 시리얼코드만 재발송할 수 있습니다.");
      }
    },
  },
};
</script>
